import { PersonAgenda } from '@esportal/portal-service';
import { useContext, useState, useEffect } from 'react';
import { PortalContext } from '../../../context/PortalContext';

const useSortedAgenda = (): PersonAgenda | null => {
	const { portalService } = useContext(PortalContext);
	const [agenda, setAgenda] = useState<PersonAgenda | null>(null);

	const sortFilterEvents = (agenda: PersonAgenda | null): PersonAgenda | null => {
		if (!agenda || !agenda.agendas) {
			return null;
		}

		const cuerrentDate = new Date();

		const activeAndUpcomingEvents = [...agenda.agendas]
			.filter((event) => {
				const eventStartDate = new Date(event.startDate);
				const eventEndDate = new Date(event.endDate);

				return cuerrentDate.getTime() >= eventStartDate.getTime() && cuerrentDate.getTime() <= eventEndDate.getTime();
			})
			.sort((a, b) => {
				const dateA = new Date(a.endDate);
				const dateB = new Date(b.endDate);

				return dateA.getTime() - dateB.getTime();
			});

		const updatedAgenda: PersonAgenda = {
			...agenda,
			agendas: activeAndUpcomingEvents,
		};

		return updatedAgenda;
	};

	useEffect(() => {
		const subscription = portalService.getPersonAgenda().subscribe((data) => {
			const sortedAgenda = sortFilterEvents(data);
			if (sortedAgenda) {
				setAgenda(sortedAgenda);
			}
		});
		return () => subscription.unsubscribe();
	}, [portalService]);

	return agenda;
};

export default useSortedAgenda;
